module.exports = __webpack_public_path__ + "static/mo25-23db65e592c7e4085ff4dcb16ff29862.png";